// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircle } from '@ni/nimble-components/dist/esm/icons/circle';
import { wrap } from '../utilities/react-wrapper';

export { type IconCircle };
export const NimbleIconCircle = wrap(IconCircle);